export const getLocalBusinessSchema = ({
    name = 'Drockerhof',
    description = 'Relax in the middle of nature',
    address = {
        streetAddress: 'San Giacomo 18',
        addressLocality: 'Funes',
        addressRegion: 'South Tyrol',
        postalCode: '39040',
        addressCountry: 'IT'
    },
    geo = {
        latitude: '46.65406102851609',
        longitude: '11.650029741684827'
    },
    telephone = '+390472840030',
    url = 'https://www.drockerhof.it',
    openingHours = 'Mo-Su 00:00-24:00',
    priceRange = '€€',
    image = 'https://www.drockerhof.it/android-chrome-192x192.png'
}) => ({
    '@context': 'https://schema.org',
    '@type': 'LocalBusiness',
    name,
    description,
    address: {
        '@type': 'PostalAddress',
        ...address
    },
    geo: {
        '@type': 'GeoCoordinates',
        ...geo
    },
    telephone,
    url,
    openingHours,
    priceRange,
    image
})

export const getBreadcrumbSchema = (items) => ({
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
        '@type': 'ListItem',
        position: index + 1,
        item: {
            '@id': item.url,
            name: item.name
        }
    }))
})

export const getFAQSchema = (questions) => ({
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: questions.map(q => ({
        '@type': 'Question',
        name: q.question,
        acceptedAnswer: {
            '@type': 'Answer',
            text: q.answer
        }
    }))
})

export const getContactPointSchema = ({
    telephone = '+390472840030',
    contactType = 'customer service',
    areaServed = 'IT',
    availableLanguage = ['German', 'Italian', 'English'],
    url = 'https://www.drockerhof.it/contact'
}) => ({
    '@context': 'https://schema.org',
    '@type': 'ContactPoint',
    telephone,
    contactType,
    areaServed,
    availableLanguage,
    url
})

export const getApartmentSchema = ({
    name,
    description,
    image,
    price = '€€',
    numberOfRooms,
    floorSize,
    amenities = [],
    url
}) => ({
    '@context': 'https://schema.org',
    '@type': 'Apartment',
    name,
    description,
    image,
    price,
    numberOfRooms,
    floorSize,
    amenities,
    url
})

export const getPriceSpecificationSchema = ({
    price,
    priceCurrency = 'EUR',
    validFrom = new Date().toISOString().split('T')[0],
    validThrough = new Date(new Date().setFullYear(new Date().getFullYear() + 1)).toISOString().split('T')[0],
    valueAddedTaxIncluded = true
}) => ({
    '@context': 'https://schema.org',
    '@type': 'PriceSpecification',
    price,
    priceCurrency,
    validFrom,
    validThrough,
    valueAddedTaxIncluded
})
